import {
    ConfigFieldType,
    FieldStatus,
    SelectorFieldDataImpl,
    SelectorOption,
    SelectorType,
    SelectorValueOptions,
} from 'adapter/in/common/form/types';
import { buildSelectorFieldData } from 'adapter/in/common/hooks/form/useBaseSelectorContainer';
import SelectorValue from 'domain/entity/preset/field/selectorValue';

export type FieldGroupContainerProps = {
    name: string;
    label: string;
    configType: ConfigFieldType;
    dataDependsOn?: string[];
    affectsTo?: string[];
    validation?: boolean;
    footer?: string;
};

export const onChangeFieldGroup = (onChange: (value: SelectorFieldDataImpl) => void, configType: ConfigFieldType) => (
    selectedValue: SelectorOption
) => {
    const getSelectorStatus = (selectValue: SelectorValueOptions, defaultValue?: string) => {
        const selectValueString = selectValue.reduce((prevValue, currentValue) => `${currentValue.id}${prevValue},`, '');
        if (selectValueString === defaultValue) return FieldStatus.DEFAULT_DATA;
        return selectValue ? FieldStatus.HAS_VALUE : FieldStatus.INVALID;
    };
    onChange(
        buildSelectorFieldData(getSelectorStatus([selectedValue]), selectedValue?.value, configType, ([
            selectedValue,
        ] as unknown) as SelectorValueOptions)
    );
};

export const mapFieldGroupOptions = (values: SelectorValue[]): SelectorValueOptions =>
    values.map(
        (value: SelectorValue): SelectorOption => ({
            type: SelectorType.FIELD_GROUP,
            value: value.id,
            label: value.properties.shortLabel ? value.properties.shortLabel : value.label,
            id: value.id,
            tooltip: value.label,
            icon: value.properties.icon,
            isDisabled: value.properties.isDisabled,
        })
    );
